import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Divider,
  Card,
  CardContent,
  CardHeader,
  Badge,
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import DeployIcon from '@material-ui/icons/CloudUpload';
import LockIcon from '@material-ui/icons/Lock';
import { DeploymentCardProps } from '../../types/deployment';
import { getStatusIcon, getStatusColor } from '../../utils/status.tsx';
import { useDeploymentStyles } from '../../styles/deployment';
import { MetricsSection } from '../MetricsSection/MetricsSection';
import { ChangesList } from '../ChangesList/ChangesList';
import { DeploymentControls } from '../DeploymentControls/DeploymentControls';

export const DeploymentCard = ({
  title,
  logo,
  statusText,
  statusType,
  newRelicStatus = null,
  newRelicType = null,
  lastDeploy,
  changes,
  isLocked,
  onLockToggle,
  deploymentProgress = 0,
  environment,
}: DeploymentCardProps) => {
  const classes = useDeploymentStyles();

  return (
    <Card className={classes.deploymentCard} elevation={2}>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Box className={classes.logoContainer}>
            {logo ? (
              <img
                src={logo}
                alt={title}
                style={{ width: 95, height: 32, borderRadius: 4 }}
              />
            ) : (
              <DeployIcon color="primary" />
            )}
          </Box>
        }
        title={
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              {title}
            </Typography>
            <Box display="flex">
              <Chip
                label={environment}
                size="small"
                variant="outlined"
                style={{ textTransform: 'capitalize' }}
              />
              <Badge
                className={classes.statusBadge}
                badgeContent={
                  isLocked ? <LockIcon style={{ fontSize: 14 }} /> : null
                }
                color="secondary"
              >
                { newRelicStatus && newRelicType &&
                  (
                    <Chip
                      className={classes.statusChip}
                      icon={getStatusIcon(newRelicType)}
                      label={`New Relic: ${newRelicStatus}`}
                      style={{
                        backgroundColor: alpha(getStatusColor(newRelicType), 0.1),
                        color: getStatusColor(newRelicType),
                        border: `1px solid ${alpha(getStatusColor(newRelicType), 0.3)}`,
                      }}
                    />
                  )
                }
              </Badge>
            </Box>
          </Box>
        }
      />

      <CardContent>
        <MetricsSection
          statusType={statusType}
          statusText={statusText}
          changesCount={changes.length}
          deploymentProgress={deploymentProgress}
          lastDeploy={lastDeploy}
        />

        <Divider style={{ margin: '1rem 0' }} />

        <ChangesList changes={changes} />

        <DeploymentControls
          isLocked={isLocked}
          onLockToggle={onLockToggle}
          title={title}
        />
      </CardContent>
    </Card>
  );
};
